import styled from "styled-components";
import { responsive } from "../../styles/constants.style";

export const ViewerWithCollapsibleHeaderWrapper = styled.div`
  .container-box {
    margin: 24px;

    ${responsive.MOBILE`
      margin: 0 8px 16px 8px;
    `}

    ${responsive.TABLET_LANDSCAPE`
      margin: 0 16px 16px 16px;
    `}
  }
  .container-header {
    margin-bottom: 16px;
  }
  .label-value-container {
    margin-top: 0;
  }
`;
